import Footer from './Sections/Footer'
import Copyright from './Sections/Copyrights'
import './Styles/appFooter.scss'

export default function AppFooter() {
  return (
    <footer className="AppFooter mt-3">
      <Footer />
      <Copyright />
    </footer>
  )
}